import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Header, Menu } from "@drconsulta/library";
import intl from 'react-intl-universal';
import { Home, Clipboard, Trello, DollarSign } from "react-feather";

import { User } from "shared/services/user.service";
import UserContext from "shared/context/user.context";
import BaseAxios from "shared/services/base-axios.service";
import { closeModal, openModal } from "shared/stores/modal-error/actions";
import { connect } from "react-redux";
import AppProps from "app-props.model";
import ModalError from "shared/components/modalError/modal-error.component";
import { JWTData } from "shared/models/auth.model";
import { PermissaoRecursos } from "shared/services/permissao-recursos.service";

const locales = {
    'pt-BR': require('./shared/lang/ptBr.json'),
};

class App extends React.Component<AppProps> {

    user = new User()
    recursos = PermissaoRecursos
    axios: BaseAxios;

    menu = [
        {
            texto:'Visão geral',
            icone: Home,
            path:'/dashboard',
            recurso: PermissaoRecursos.PAGINA_DASHBOARD
        },
        {
            texto:'Parceiros',
            icone: Clipboard, 
            path:'/parceiros',
            recurso: PermissaoRecursos.PAGINA_PARCEIROS
        },
        {
            texto:'Vouchers e Laudos',
            icone: Trello, 
            path:'/vouchers',
            recurso: PermissaoRecursos.PAGINA_VOUCHERS
        },
        {
            texto:'Financeiro',
            icone: DollarSign, 
            path:'/extratos',
            recurso: PermissaoRecursos.PAGINA_FINANCEIRO
        }
    ]

    setLoginIn = loginIn => {
        this.setState({ loginIn });
    };

    state = {
        menuAberto: false,
        indexMenu:0,
        loginIn: false,
        setLoginIn: this.setLoginIn,
        menuUsuario:[]
    }

    constructor(props) {
        super(props);

        this.setLocation();
        this.setDefaultAxios();
    }

    setDefaultAxios(){
        this.axios = new BaseAxios((value) => {
            this.modalError(value);
        });
    }

    getMenuUsuario(){
        let jwtData = this.user.getTokenDecode();

        if(jwtData != null){
            let nome = this.user.getNomeUsuario();
            let newMenus = this.montaMenuUsuario(jwtData);

            let newMenuUsuario = {
                titulo: `${intl.get('header.bemvindo')}, <br/> ${nome}`,
                menus: newMenus
            };

            return newMenuUsuario;
        }

        return {};
    }

    montaMenuUsuario(jwtData: JWTData){
        if(this.user.isParceiro()){
            return [
                {
                    path: `/parceiros/${jwtData.partnerId}`,
                    name: "Dados Laboratório"
                },
                {
                    name: "SAIR"
                }
            ];
        } else {
            return [
                {
                    name: "SAIR"
                }
            ];
        }
    }

    componentDidMount(){
        this.setTimeoutRefresh()
        this.menuItemsPermitidos()
    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.loginIn !== this.state.loginIn)
            this.menuItemsPermitidos()
    }

    menuItemsPermitidos(){
        const recursosPermitidos = new PermissaoRecursos()
        this.setState({
            menuUsuario: this.menu.filter( e => recursosPermitidos.temPermissao(e.recurso))
        })
        
    }

    setLocation(){
        let currentLocale = locales[navigator.language] ? navigator.language : 'pt-BR';
    
        intl.init({
            currentLocale,
            locales
        });
    }

    setTimeoutRefresh(){
        if(this.user.isAuthenticated()){
            setTimeout(()=>{
                this.user.refreshToken()
            }, this.user.getExpireToken().getMinutes() * 60 * 1000);
        }
    }

    abrirMenu(){
        this.setState( { menuAberto: !this.state.menuAberto })
    }

    modalError(error){
        console.log(error);
        this.props.openModal(error);
    }

    menuUsuarioClick(item){
        if(item === "SAIR"){
            this.user.logout();
            window.location.href = "/";
        }
    }

    showMenuLogado(){
        let isntPrimeiroAcesso = this.props.location.pathname !== "/primeiro-acesso";

        return this.user.isAuthenticated() && isntPrimeiroAcesso;
    }
    
    render() {
        const { menuAberto, indexMenu } = this.state
    
        return (
            <UserContext.Provider value={this.state}>
                <Header 
                    menu={this.showMenuLogado()} 
                    onClickMenu={ () => this.abrirMenu()}
                    onClickMenuUsuario={(item) => this.menuUsuarioClick(item)}
                    usuario={this.getMenuUsuario()}
                    menuUsuario={this.showMenuLogado()} 
                    RouterLink={Link}
                />
                <Menu open={menuAberto} indexSelecionado={indexMenu} menu={this.state.menuUsuario} RouterLink={Link} onChangeOpen={(e) => this.setState( { menuAberto:false, indexMenu:e })} />
                {this.props.children}

                <ModalError 
                    errorMessage={this.props.errorMessage} 
                    mostrarModal={this.props.modalIsOpen} 
                    fecharModal={() => this.props.closeModal()}
                />
            </UserContext.Provider>
        );

    }
}

const mapStateToProps = (store) => ({
    modalIsOpen: store.modalError.openModal,
    errorMessage: store.modalError.errorMessage
});

const mapDispatchToProps = (dispatch) => ({
    openModal: (value) => {
        dispatch(openModal(value));
    },
    closeModal: () => {
        dispatch(closeModal());
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
